import React from "react";
import { Toaster as SonnerToaster } from "sonner";
export function Toaster() {
    return React.createElement(SonnerToaster, { position: "bottom-center" });
}
